

























import { Component, Vue } from "vue-property-decorator";
import { State, Mutation } from "vuex-class";

@Component
class DefaultLayoutModals extends Vue {
  @State(state => state.app.toast) toast;

  @State(state => state.app.paying) paying;

  @Mutation("app/SET_TOAST") setToast;

  @Mutation("app/SET_PAYING") setPaying;

  handleToastChange(val) {
    this.setToast({ show: val });
  }

  handlePayingCancel() {
    this.setPaying({ visible: false });
  }
}
export default DefaultLayoutModals;
